import React from 'react';
import Layout from '../components/Layout';
import Welcome from '../components/welcome'

const IndexPage = () => (
  <Layout>
    <Welcome/>    
  </Layout>
);
export default IndexPage;
